import styled from 'styled-components'
import { ImageFullContainerRecord, TextDescriptionRecord } from 'types'
import { ImageAndTextIconListItem } from '@/blocks/ImageAndTextIconListItem'

const StyledCard = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0.5fr 0.5fr 1.5fr;
  gap: 0px 0px;
  grid-template-areas: 'image-container' 'text-container' 'list-container';
  
  height: 500px;
  background-color: ${(p) => p.theme.v2.surface.cream500};
  border-radius: 24px;
  padding-bottom: 32px;
  .header-image {
    border-radius: 24px 24px 0 0;
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    width: 60vw;
    height: 466px;
    margin: 0 auto;
    grid-template-columns: 1fr;
    grid-template-rows: 0.5fr 0.4fr 1.35fr;
    .text-container {
      p {
        font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
        line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
      }
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    width: unset;
    margin: unset;
    grid-template-columns: 1fr;
    grid-template-rows: 0.5fr 0.5fr 1.25fr;
    .text-container {
      p {
        font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
        line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
      }
`
const StyledText = styled.div`
  grid-area: text-container;
  padding: 0 40px;
  margin-top: 32px;
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    padding: 0 24px 8px 24px;
    margin-top: 24px;
  }

  h3 {
    font-size: ${(p) => p.theme.v2.typography.body.l.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.l.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    color: ${(props) => props.theme.v2.onSurface.subduedText};
    margin: 0;
    padding: 0;
  }

  h4 {
    font-size: ${(p) => p.theme.v2.typography.display.xs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.xs.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    color: ${(props) => props.theme.v2.onSurface.text};
    padding: 0;
    margin: 0;
  }
  p {
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    text-align: left;
    padding-bottom: 22px;
    border-bottom: 1px solid #e2dfdb;
    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.xxs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xxs.lineHeight};
      padding-bottom: 16px;
      margin-bottom: 16px;
    }
  }
`

const StyledHeading = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  justify-content: start;
  align-items: flex-start;
  padding-bottom: 32px;
  border-bottom: 1px solid #e2dfdb;
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    h3 {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    }
    h4 {
      font-size: ${(p) => p.theme.v2.typography.display.xxs.fontSize};
    }

`
const StyledListContainer = styled.div`
  padding: 32px 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  grid-area: list-container;
  gap: 24px;
  margin-bottom: 40px;
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    padding: 0 20px;
    margin-bottom: 32px;
  }
`
type TwoColumnFeatureCardWithListProps = {
  title: string
  textBlock: string
  listContent: {
    blocks: {
      id: string
      leftSection: ImageFullContainerRecord | TextDescriptionRecord
      rightSection: ImageFullContainerRecord | TextDescriptionRecord
    }[]
  }
}

export const TwoColumnFeatureCardWithListNoImage = ({
  title,
  textBlock,
  listContent,
}: TwoColumnFeatureCardWithListProps) => {
  return (
    <StyledCard>
      <StyledText>
        <StyledHeading>
          <h3>{title}</h3>
        </StyledHeading>
        {textBlock && <p>{textBlock}</p>}
      </StyledText>
      <StyledListContainer>{listContent.blocks.map((item) => ImageAndTextIconListItem({ item }))}</StyledListContainer>
    </StyledCard>
  )
}
